import React, { FunctionComponent } from 'react';
import styles from './img-title-description.module.scss';
import classNames from 'classnames/bind';
import { IButtonProps, Button } from '../button/button';
import { InternalLink } from '../internal-link/internal-link';
import { emptyWyswigString } from '../../utils/utils';

export interface IImgTitleDescriptionComponentProps {
  img: string;
  title: string;
  description?: string;
  alignItems: string;
  justifyContent: string;
  backgroundColor: string;
  textColor: string;
  withBorder: boolean;
  button: IButtonProps;
  urlToPage: string;
  descriptionHasOverlay: boolean;
  hasHoverEffect: boolean;
  fullWidth: string;
  uniqueId: string;
}

const cx = classNames.bind(styles);

export const ImgTitleDescriptionComponent: FunctionComponent<IImgTitleDescriptionComponentProps> = props => {
  const {
    img,
    title,
    description,
    alignItems,
    justifyContent,
    backgroundColor,
    textColor,
    withBorder,
    button,
    urlToPage,
    descriptionHasOverlay,
    hasHoverEffect,
    fullWidth,
    uniqueId
  } = props;
  const containerClassname = cx({
    componentContainer: true,
    alignLeft: alignItems === 'left',
    alignRowCenter: alignItems === 'center',
    alignRight: alignItems === 'right',
    alignTop: justifyContent === 'top',
    alignColumnCenter: justifyContent === 'center',
    alignBottom: justifyContent === 'down',
    backgroundColorWhite: backgroundColor === 'white',
    backgroundColorSecondary: backgroundColor === 'secondary',
    backgroundColorLightGray: backgroundColor === 'light_gray',
    backgroundColorTransparent: backgroundColor === 'transparent',
    withBoarder: withBorder && textColor !== 'secondary',
    withBoarderSecondary: withBorder && textColor === 'secondary',
    hasHoverEffect: hasHoverEffect,
    withButton: button ? true : false,
    fullWidth: fullWidth && fullWidth === 'yes'
  });

  const titleClassname = cx({
    title: true,
    textAlignLeft: alignItems === 'left',
    textAlignCenter: alignItems === 'center',
    textAlignRight: alignItems === 'right',
    headerPrimary: textColor === 'primary',
    primaryColor: textColor === 'secondary',
    secondaryColor: textColor === 'tertiary',
    colorBlack: textColor === 'black'
  });

  const descriptionClassname = cx({
    description: true,
    textAlignLeft: alignItems === 'left',
    textAlignCenter: alignItems === 'center',
    textAlignRight: alignItems === 'right',
    primaryColor: textColor === 'primary' || textColor === 'secondary',
    secondaryColor: textColor === 'tertiary',
    colorBlack: textColor === 'black',
    noPadding: !button
  });

  const content = (
    <React.Fragment>
      {img && (
        <div data-item="image-wrapper">
          <img
            src={img}
            className={`${styles.img} ${title === emptyWyswigString &&
              styles.smallPadding}`}
            alt="Item"
          />
        </div>
      )}
      {title !== emptyWyswigString && (
        <div
          className={titleClassname}
          dangerouslySetInnerHTML={{ __html: title }}
        ></div>
      )}
      {description !== emptyWyswigString && (
        <div
          dangerouslySetInnerHTML={{ __html: description }}
          className={`${descriptionClassname} ${
            descriptionHasOverlay ? styles.descriptionWithOverlay : null
          }`}
        ></div>
      )}
      {button && <Button {...button} />}
    </React.Fragment>
  );
  return (
    <React.Fragment>
      {urlToPage ? (
        <InternalLink
          id={uniqueId.length ? uniqueId : undefined}
          className={containerClassname}
          url={urlToPage}
        >
          {content}
        </InternalLink>
      ) : (
        <div
          id={uniqueId.length ? uniqueId : undefined}
          className={containerClassname}
        >
          {content}
        </div>
      )}
    </React.Fragment>
  );
};
